var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from '@mui/icons-material';
import { Autocomplete, Badge, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormHelperText, Grid, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, TextField, Typography, useTheme } from '@mui/material';
import { ArrowLeft02Icon, ArrowRight03Icon, Unlink05Icon } from 'hugeicons-react';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { X } from 'react-feather';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { useUpdateClientMachineMutation, useUpdateSerialNumberMutation } from '../../../../../application/features/machines/machine-api';
import useTranslate from '../../../../../localization/helpers';
import ReAssignSerial from '../../../../components/ReAssignSerial';
import EditSerialNumbers from './EditSerialNumbers';
var EditModel = function (_a) {
    var _b;
    var open = _a.open, onClose = _a.onClose, machineId = _a.machineId, machineModels = _a.machineModels;
    var theme = useTheme();
    var _c = useTranslate(), translate = _c.translate, tWithField = _c.tWithField, tWithFunction = _c.tWithFunction;
    var _d = __read(useState(null), 2), anchorEl = _d[0], setAnchorEl = _d[1];
    var _e = __read(useState(false), 2), menuRowId = _e[0], setMenuRowId = _e[1];
    var _f = __read(useState('edit'), 2), viewMode = _f[0], setViewMode = _f[1];
    var _g = __read(useState([]), 2), selectedSerials = _g[0], setSelectedSerials = _g[1];
    var _h = __read(useState(false), 2), selectAll = _h[0], setSelectAll = _h[1];
    var hasNullClient = machineModels.some(function (m) { return m.clientId === null; });
    var clients = __spreadArray(__spreadArray([], __read((hasNullClient ? [{ id: null, name: translate('common.noClients') }] : [])), false), __read(new Map(machineModels.map(function (m) { return [m.clientId, { id: m.clientId, name: m.clientName }]; })).values()), false);
    var _j = __read(useUpdateSerialNumberMutation(), 2), updateSerialNumbers = _j[0], _k = _j[1], isLoading = _k.isLoading, isSuccess = _k.isSuccess;
    var _l = __read(useUpdateClientMachineMutation(), 2), triggerUpdateClientMachine = _l[0], _m = _l[1], isUpdateClientMachineLoading = _m.isLoading, isUpdateClientMachineSuccess = _m.isSuccess;
    var _o = useForm({
        defaultValues: {
            clientId: '',
            machineId: '',
            machineData: []
        }
    }), control = _o.control, reset = _o.reset, getValues = _o.getValues, clearErrors = _o.clearErrors, setError = _o.setError, handleSubmit = _o.handleSubmit, watch = _o.watch, setValue = _o.setValue, errors = _o.formState.errors;
    var updateClientMachineForm = useForm({
        defaultValues: {
            clientId: null,
            modelNumber: '',
            serialNumbers: [],
            machineId: '',
            oldClientId: null
        }
    });
    var fields = useFieldArray({
        name: 'machineData',
        control: control
    }).fields;
    var clientId = watch('clientId');
    var serialNumbers = ((_b = machineModels === null || machineModels === void 0 ? void 0 : machineModels.find(function (x) { return x.clientId === clientId; })) === null || _b === void 0 ? void 0 : _b.serialNumbers) || [];
    var totalSerials = serialNumbers.length;
    var reAssignClients = clients.filter(function (client) { return client.id !== null && client.id !== clientId; });
    var modelNumber = machineModels[0].modelNumber;
    useEffect(function () {
        if (machineModels)
            reset({
                machineId: machineId
            });
    }, [machineId, machineModels, reset]);
    useEffect(function () {
        if (clientId === null || (clientId && machineModels)) {
            var clientModels = machineModels.filter(function (m) { return m.clientId === clientId; });
            var machineData = clientModels.map(function (model) {
                return ({
                    modelNumber: model.modelNumber,
                    serialNumbers: model.serialNumbers.map(function (serialNumber) { return ({ serialNumber: serialNumber }); }),
                    deletedSerialNumbers: []
                });
            });
            setValue('machineData', machineData, { shouldValidate: true });
        }
    }, [clientId, machineModels, setValue]);
    useEffect(function () {
        if (isSuccess || isUpdateClientMachineSuccess) {
            enqueueSnackbar(tWithField('toolTips.updateSuccess', 'common.record'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
            closeDialog();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess, isUpdateClientMachineSuccess]);
    var handleMenuClick = function (event) {
        setAnchorEl(event.currentTarget);
        setMenuRowId(true);
    };
    var closeDialog = function () {
        reset();
        onClose();
    };
    var handleMenuClose = function () {
        setAnchorEl(null);
        setMenuRowId(false);
    };
    var handleReAssignClick = function () {
        setViewMode('reassign');
        handleMenuClose();
    };
    var handleDeLinkClick = function () {
        setViewMode('delink');
        handleMenuClose();
    };
    var handleBackToEdit = function () {
        setViewMode('edit');
        setSelectedSerials([]);
        setSelectAll(false);
        updateClientMachineForm.reset();
    };
    var handleReassignSubmit = function (reassignClient) {
        reassignClient.modelNumber = modelNumber;
        reassignClient.machineId = machineId;
        reassignClient.serialNumbers = selectedSerials;
        if (clientId)
            reassignClient.oldClientId = clientId;
        triggerUpdateClientMachine(reassignClient);
    };
    var handleDelinkSubmit = function (delinkClient) {
        delinkClient.modelNumber = modelNumber;
        delinkClient.machineId = machineId;
        delinkClient.serialNumbers = selectedSerials;
        delinkClient.clientId = null;
        if (clientId)
            delinkClient.oldClientId = clientId;
        triggerUpdateClientMachine(delinkClient);
    };
    var findDuplicateSerialNumber = function (machineData) {
        var allSerialNumbers = machineData.flatMap(function (model, modelIndex) {
            return model.serialNumbers.map(function (s, serialIndex) { return ({
                serialNumber: s.serialNumber.trim().toLowerCase(),
                modelIndex: modelIndex,
                serialIndex: serialIndex
            }); });
        });
        var serialNumberMap = new Map();
        allSerialNumbers.forEach(function (_a) {
            var serialNumber = _a.serialNumber, modelIndex = _a.modelIndex, serialIndex = _a.serialIndex;
            if (!serialNumberMap.has(serialNumber)) {
                serialNumberMap.set(serialNumber, []);
            }
            serialNumberMap.get(serialNumber).push({ modelIndex: modelIndex, serialIndex: serialIndex });
        });
        var hasDuplicates = false;
        serialNumberMap.forEach(function (occurrences) {
            if (occurrences.length > 1) {
                hasDuplicates = true;
                occurrences.forEach(function (_a) {
                    var modelIndex = _a.modelIndex, serialIndex = _a.serialIndex;
                    setError("machineData.".concat(modelIndex, ".serialNumbers.").concat(serialIndex, ".serialNumber"), {
                        message: tWithField('validations.isUnique', 'asset.serialNumber')
                    });
                });
            }
        });
        return !hasDuplicates;
    };
    var handleSubmitForm = function (updatedMachine) {
        var isValid = findDuplicateSerialNumber(updatedMachine.machineData);
        if (isValid) {
            updatedMachine.machineId = machineId;
            var machineModel_1 = machineModels === null || machineModels === void 0 ? void 0 : machineModels.find(function (m) { return m.clientId === updatedMachine.clientId; });
            updatedMachine.machineData.forEach(function (machineData) {
                var machineSerialNumbers = machineData.serialNumbers.map(function (sr) { return sr.serialNumber; });
                machineData.deletedSerialNumbers = machineModel_1 === null || machineModel_1 === void 0 ? void 0 : machineModel_1.serialNumbers.filter(function (sr) { return !machineSerialNumbers.includes(sr); });
            });
            var prevSerialNumbers_1 = (machineModel_1 === null || machineModel_1 === void 0 ? void 0 : machineModel_1.serialNumbers) || [];
            var currentSerialNumbers = updatedMachine.machineData.flatMap(function (md) {
                return md.serialNumbers.map(function (sn) { return sn.serialNumber; });
            });
            updatedMachine.addedSerialNumbers = currentSerialNumbers.filter(function (sn) { return !prevSerialNumbers_1.includes(sn); });
            if (!updatedMachine.machineData.map(function (x) { return x.modelNumber; }).includes(machineModel_1 === null || machineModel_1 === void 0 ? void 0 : machineModel_1.modelNumber)) {
                updatedMachine.oldModelNumber = machineModel_1 === null || machineModel_1 === void 0 ? void 0 : machineModel_1.modelNumber;
            }
            if (hasNullClient)
                updatedMachine.hasNullClient = hasNullClient;
            updateSerialNumbers(updatedMachine);
        }
    };
    var renderEditContent = function () { return (_jsxs(_Fragment, { children: [_jsx(Box, { component: 'form', noValidate: true, autoComplete: 'off', children: _jsx(Grid, { container: true, spacing: 3, p: 1, children: _jsx(Grid, { size: { xs: 12, md: 12, sm: 12, lg: 12 }, children: _jsx(Controller, { name: 'clientId', control: control, rules: {
                                required: {
                                    value: clientId !== null,
                                    message: tWithField('validations.fieldIsRequired', 'common.client')
                                }
                            }, render: function (_a) {
                                var _b;
                                var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                return (_jsxs(FormControl, { size: 'medium', fullWidth: true, variant: 'outlined', children: [_jsx(Autocomplete, { sx: {
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '8px'
                                                }
                                            }, disabled: isLoading, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, value: clients.find(function (client) { return value === client.id; }) || null, options: clients || [], getOptionLabel: function (option) { return option.name; }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { disabled: isLoading, error: !!errors.clientId, variant: 'outlined', fullWidth: true, label: translate('common.client') }))); }, onChange: function (_, value) {
                                                onChange(value === null || value === void 0 ? void 0 : value.id);
                                            }, renderOption: function (props, option) {
                                                return option !== null && (_createElement("li", __assign({}, props, { key: option.id }), option.name));
                                            }, noOptionsText: translate('common.noClients') }), _jsx(FormHelperText, { error: true, children: (_b = errors.clientId) === null || _b === void 0 ? void 0 : _b.message })] }));
                            } }) }) }) }), (clientId === null || clientId) && (_jsxs(Box, { mt: 1, display: 'flex', flexDirection: 'column', gap: '16px', children: [_jsx(Box, { display: 'flex', justifyContent: 'space-between', width: '100%', children: _jsx(Typography, { variant: 'subtitle1', color: theme.palette.grey[700], children: translate('common.modelNumbers') }) }), fields.map(function (field, index) { return (_jsx(Grid, { container: true, spacing: 2, children: _jsx(Grid, { size: { xs: 12 }, children: _jsxs(Box, { p: '8px 16px', gap: 2, flexDirection: 'column', borderRadius: '12px', bgcolor: '#FFFFFF', boxShadow: theme.customShadows.z8, position: 'relative', children: [_jsx(Badge, { overlap: 'circular', badgeContent: index + 1, sx: {
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            zIndex: 10,
                                            '& .MuiBadge-badge': {
                                                backgroundColor: '#E4E6EB',
                                                color: '#161C24'
                                            }
                                        } }), _jsxs(Box, { display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1, children: [_jsx(Controller, { name: "machineData.".concat(index, ".modelNumber"), control: control, rules: {
                                                    required: tWithField('validations.fieldIsRequired', 'assets.modelNumber'),
                                                    validate: function (value) {
                                                        var isDuplicate = fields.some(function (item, i) {
                                                            return i !== index && item.modelNumber.toLowerCase() === value.toLowerCase();
                                                        });
                                                        return isDuplicate
                                                            ? tWithField('validations.isUnique', 'assets.modelNumber')
                                                            : true;
                                                    }
                                                }, render: function (_a) {
                                                    var _b, _c, _d, _e, _f, _g, _h;
                                                    var field = _a.field;
                                                    return (_jsxs(FormControl, { disabled: isLoading, fullWidth: true, error: !!((_c = (_b = errors.machineData) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.modelNumber), children: [_jsx(Box, { display: 'flex', justifyContent: 'space-between', gap: 1, children: _jsx(TextField, __assign({ disabled: isLoading, size: 'small', label: translate('assets.modelNumber') }, field, { error: !!((_e = (_d = errors.machineData) === null || _d === void 0 ? void 0 : _d[index]) === null || _e === void 0 ? void 0 : _e.modelNumber), fullWidth: true, children: translate('assets.modelNumber') })) }), _jsx(FormHelperText, { error: true, children: (_h = (_g = (_f = errors.machineData) === null || _f === void 0 ? void 0 : _f[index]) === null || _g === void 0 ? void 0 : _g.modelNumber) === null || _h === void 0 ? void 0 : _h.message })] }));
                                                } }), _jsx(Box, { children: _jsx(Button, { variant: 'outlined', color: 'inherit', disabled: isLoading || serialNumbers.length === 0, size: 'medium', onClick: function (event) { return handleMenuClick(event); }, endIcon: anchorEl ? (_jsx(KeyboardArrowUpOutlined, { sx: { fontSize: 24 } })) : (_jsx(KeyboardArrowDownOutlined, { sx: { fontSize: 24 } })), children: translate('assets.options') }) }), _jsxs(Menu, { anchorEl: anchorEl, open: menuRowId, onClose: handleMenuClose, anchorOrigin: {
                                                    vertical: 'bottom',
                                                    horizontal: 'center'
                                                }, transformOrigin: {
                                                    vertical: 'top',
                                                    horizontal: 'center'
                                                }, children: [_jsxs(MenuItem, { disabled: reAssignClients.length === 0, onClick: handleReAssignClick, children: [_jsx(ListItemIcon, { children: _jsx(ArrowRight03Icon, { color: '#637381', fontSize: 'small' }) }), _jsx(ListItemText, { sx: { color: 'inherit' }, children: translate('assets.reassign') })] }), _jsx(Divider, {}), _jsxs(MenuItem, { disabled: clientId === null, onClick: handleDeLinkClick, children: [_jsx(ListItemIcon, { children: _jsx(Unlink05Icon, { color: '#637381', fontSize: 'small' }) }), _jsx(ListItemText, { children: translate('assets.delink') })] })] })] }), _jsx(EditSerialNumbers, { control: control, modelSerialNumberIndex: index, errors: errors, isLoading: isLoading })] }) }) }, field.id)); })] }))] })); };
    return (_jsxs(Dialog, { sx: { borderRadius: '44px' }, fullWidth: true, scroll: 'paper', open: open, maxWidth: 'sm', children: [_jsxs(DialogTitle, { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: '20px'
                }, children: [viewMode === 'edit' ? (tWithFunction('actions.updateFunction', 'assets.modelSerialNumbers')) : (_jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, children: [_jsx(IconButton, { size: 'Xs', color: 'primary', onClick: handleBackToEdit, sx: { p: 0 }, children: _jsx(ArrowLeft02Icon, { size: 20, color: theme.palette.primary.main }) }), _jsx(Typography, { variant: 'h6', component: 'div', children: translate(viewMode === 'reassign'
                                    ? 'assets.reAssignModelSerials'
                                    : 'assets.deLinkModelSerials') })] })), _jsx(IconButton, { color: 'inherit', style: { marginLeft: 'auto' }, onClick: closeDialog, children: _jsx(X, { size: 20, color: '#637381' }) })] }), _jsx(DialogContent, { dividers: true, sx: {
                    pb: 4,
                    px: 4
                }, children: viewMode === 'edit' ? (renderEditContent()) : (_jsx(ReAssignSerial, { viewMode: viewMode, form: updateClientMachineForm, clients: reAssignClients, serialNumbers: serialNumbers, totalSerials: totalSerials, modelNumber: modelNumber, isLoading: isUpdateClientMachineLoading, selectedSerials: selectedSerials, setSelectedSerials: setSelectedSerials, selectAll: selectAll, setSelectAll: setSelectAll, translate: translate })) }), _jsxs(DialogActions, { children: [_jsx(Button, { size: 'medium', variant: 'outlined', color: 'inherit', disabled: viewMode === 'edit' ? isLoading : isUpdateClientMachineLoading, onClick: closeDialog, children: translate('actions.cancel') }), viewMode === 'edit' ? (_jsx(Button, { size: 'medium', variant: 'contained', color: 'warning', disabled: isLoading, onClick: handleSubmit(handleSubmitForm), children: translate('actions.saveChanges') })) : viewMode === 'reassign' ? (_jsxs(Button, { size: 'medium', variant: 'contained', color: 'warning', disabled: isUpdateClientMachineLoading || selectedSerials.length === 0, onClick: updateClientMachineForm.handleSubmit(handleReassignSubmit), children: [translate('assets.reAssignAll'), " (", selectedSerials.length, ")"] })) : (_jsxs(Button, { size: 'medium', variant: 'contained', color: 'warning', disabled: isUpdateClientMachineLoading || selectedSerials.length === 0, onClick: updateClientMachineForm.handleSubmit(handleDelinkSubmit), children: [translate('assets.deLinkAll'), " (", selectedSerials.length, ")"] }))] })] }));
};
export default EditModel;
